import assignmentHelper from '../assignment/assignmentHelper';
import dataType from '../../../constants/dataType';
import NumberDeclarationHelper from '../../../types/Functions/NumberDeclarationHelper';
import ReportVariable from '../../../../types/report/ReportVariable';
import Mode from '../../../../types/report/Mode';
import ReportConfig from '../../../../types/report/ReportConfig';
import assignmentOperandHelper from '../assignment/assignmentOperandHelper';

class VariableHelper extends NumberDeclarationHelper<ReportVariable> {

    getDeclarations(config: ReportConfig): ReportVariable[] {

        return config.variables;
    }

    getEmpty(rawDataSourceId: number | null): ReportVariable {

        let assignment = assignmentHelper.getEmpty(false);
        assignment.number = 1;

        return {
            id: null,
            name: '',
            number: 0,
            dataSourceId: rawDataSourceId,
            dataType: dataType.boolean,
            assignment: assignment,
            businessDescription: '',
            isSystem: false,
            errors: [],
            _internalId: 1,
            lastUpdatedTime: undefined,
            mode: Mode.Local,
            globalVariableModuleId: 0
        };
    }

    isVariablereferencedInVariables(variableNumber: number, variables: ReportVariable[]): ReportVariable | null {

        for (let index = 0; index < variables.length; index++) {

            let v = variables[index];

            let operands = assignmentOperandHelper.getAll(v.assignment);

            if (operands.some(x => x.variableNumber === variableNumber)) {

                return v;
            }
        }

        return null;
    }
}

const variableHelper = new VariableHelper();

export default variableHelper;
